"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = void 0;
var React = require("react");
var services_1 = require("@falcon/services");
var Header = /** @class */ (function (_super) {
    __extends(Header, _super);
    function Header() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Header.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement("div", { className: "journey-bg" },
                React.createElement("div", null,
                    React.createElement("img", { className: "waves", src: "/img/Flow-waves.svg", alt: "Journey background waves" }),
                    React.createElement("img", { className: "clouds", src: "/img/Flow-clouds.svg", alt: "Journey background clouds" }))),
            React.createElement("div", { className: "journey-header" },
                React.createElement("div", { className: "journey-header-background" },
                    React.createElement("a", { className: "header-logo-link", id: "goToAllianzHomePage", href: "https://www.allianz.co.uk", target: "_blank", "aria-label": "Link to Allianz home page" },
                        React.createElement("img", { className: "flow-logo", src: "/".concat(services_1.resourcesHelper.THEME, "/img/brand-logo.png"), alt: "".concat(services_1.resourcesHelper.THEME, " logo icon"), tabIndex: 0 }))))));
    };
    return Header;
}(React.Component));
exports.Header = Header;
//# sourceMappingURL=Header.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/navigator/Header.js
// module id = 651
// module chunks = 0